import { render } from "./Popup.vue?vue&type=template&id=9d8e8834&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=9d8e8834&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d8e8834"],['__file',"src/assets/js/components/Popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d8e8834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d8e8834', __exports__)) {
    api.reload('9d8e8834', __exports__)
  }
  
  module.hot.accept("./Popup.vue?vue&type=template&id=9d8e8834&scoped=true", () => {
    api.rerender('9d8e8834', render)
  })

}


export default __exports__